import React, { Component } from 'react'
import GoogleMapReact from 'google-map-react'
import Swal from 'sweetalert2'
import axios from 'axios'
import StoreMapMarker from './StoreMapMarker'
import Constant from '../../Constant'

export default class StoreMapView extends Component {
  state = {
    center: {
      lat: 29.281596,
      lng: 47.9602518,
    },
    lat: null,
    lng: null,

    zoom: 9,

    deliveryArea: 'No Area Selected',
    stores: [],
    stores_ar: [],

    country: '',
    state: '',
    locality: '',
    sublocality: '',
    area: '',

    loading: false,

    searchInput: '',
  }

  handleMapClick = (event) => {
    this.checkdetails(event)
  }

  checkdetails = async (event) => {
    let latitude = event.lat
    let longitude = event.lng

    this.setState({
      stores_ar: [],
      stores: [],
    })

    await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&language=en&key=AIzaSyASpObdwRz7rN1j5NdZJ7a_-5mkGypEZRY`
    )
      .then((response) => response.json())
      .then((data) => {

        let area
        let state
        let city
        let sublocality
        let country

        for (let index = data.results.length - 1; index >= 0; index--) {
          if (data.results[index].types.includes('country')) {
            country = data.results[index].formatted_address
          }
          if (data.results[index].types.includes('administrative_area_level_1')) {
            state = data.results[index].address_components.find((value) =>
              value.types.includes('administrative_area_level_1')
            ).long_name
          }
        }

        for (let index = data.results.length - 1; index >= 0; index--) {
          if (data.results[index].types.includes('locality')) {
            city = data.results[index].address_components.find((value) => value.types.includes('locality')).long_name
            break
          }

          if (data.results[index].types.includes('sublocality')) {
            city = data.results[index].address_components.find((value) => value.types.includes('sublocality')).long_name
            break
          }

          if (data.results[index].types.includes('sublocality_level_1')) {
            city = data.results[index].address_components.find((value) =>
              value.types.includes('sublocality_level_1')
            ).long_name
            break
          }
        }
        if (city) {
          this._onClick(event)
        } else {
          this.setState({
            deliveryArea: 'Not found',
          })
        }

        this.setState({
          lat: latitude || null,
          lng: longitude || null,

          country: country || null,
          state: state || null,
          locality: city || null,
          sublocality: sublocality || null,
          area: area || null,
        })
      })
      .catch(() => {
        // console.log('Error:', error);
      })
    await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&language=ar&key=AIzaSyASpObdwRz7rN1j5NdZJ7a_-5mkGypEZRY`
    )
      .then((response) => response.json())
      .then((data) => {

        let area
        let state
        let city
        let sublocality
        let country

        for (let index = data.results.length - 1; index >= 0; index--) {
          if (data.results[index].types.includes('country')) {
            country = data.results[index].formatted_address
          }
          if (data.results[index].types.includes('administrative_area_level_1')) {
            state = data.results[index].address_components.find((value) =>
              value.types.includes('administrative_area_level_1')
            ).long_name
          }
        }

        for (let index = data.results.length - 1; index >= 0; index--) {
          if (data.results[index].types.includes('locality')) {
            city = data.results[index].address_components.find((value) => value.types.includes('locality')).long_name
            break
          }

          if (data.results[index].types.includes('sublocality')) {
            city = data.results[index].address_components.find((value) => value.types.includes('sublocality')).long_name
            break
          }

          if (data.results[index].types.includes('sublocality_level_1')) {
            city = data.results[index].address_components.find((value) =>
              value.types.includes('sublocality_level_1')
            ).long_name
            break
          }
        }

        this.setState({
          lat: latitude || null,
          lng: longitude || null,

          country_ar: country || null,
          state_ar: state || null,
          locality_ar: city || null,
          sublocality_ar: sublocality || null,
          area_ar: area || null,
        })
      })
      .catch(() => {
        // console.log('Error:', error);
      })
  }

  _onClick = async (value) => {
    this.setState({
      lat: value.lat,
      lng: value.lng,
      loading: true,
    })

    await axios
      .get(Constant.getAPI() + '/store/stores-by-coords?coords=' + value.lat + ',' + value.lng + '&lang=en', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        const data = res.data.data
        this.setState({
          stores: data.list,
          deliveryArea: data.deliveryArea,
          loading: false,
        })
      })
      .catch((err) => {
        this.setState({
          loading: false,
        })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })

    await axios
      .get(Constant.getAPI() + '/store/stores-by-coords?coords=' + value.lat + ',' + value.lng + '&lang=ar', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        const data = res.data.data
        this.setState({
          stores_ar: data.list,
          loading: false,
        })
      })
      .catch((err) => {
        this.setState({
          loading: false,
        })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleInputChange = (event) => {
    this.setState({
      searchInput: event.target.value,
    })
  }

  PlacesAutocomplete = () => {
    return (
      <div
        style={{
          position: 'absolute',
          top: 10,
          left: 10,
          zIndex: 10,
        }}
      >
        <form onSubmit={() => { }}>
          <input
            type="text"
            value={this.state.searchInput}
            onChange={this.handleInputChange}
            placeholder="Search for any location"
            style={{
              width: 300,
              padding: 5,
              marginRight: 10,
              borderRadius: 10,
            }}
          />
          <button
            type="submit"
            style={{ borderRadius: 10, height: 30, width: 100 }}
          >
            Search
          </button>
        </form>
      </div>
    )
  }

  render() {
    return (
      <div>
        <div style={{ height: '30rem', width: '100%' }}>
          {/* {this.PlacesAutocomplete()} */}
          <GoogleMapReact
            bootstrapURLKeys={{
              key: 'AIzaSyASpObdwRz7rN1j5NdZJ7a_-5mkGypEZRY',
              language: 'en',
              region: 'kw',
            }}
            defaultCenter={this.state.center}
            defaultZoom={this.state.zoom}
            onClick={this.handleMapClick}
          >
            <StoreMapMarker
              text="Marker"
              lat={this.state.lat}
              lng={this.state.lng}
            />
          </GoogleMapReact>
        </div>
        {!this.state.loading ? (
          <div>
            <div className="card m-1">
              <div className="card-body text-center p-1">
                <h3 className="card-title">Area Name: {this.state.deliveryArea}</h3>
                <h6 className="mt-2">
                  {this.state.country && ' | Country:- ' + this.state.country}
                  {this.state.country_ar && ' / ' + this.state.country_ar}
                  {this.state.state && ' | State:- ' + this.state.state}
                  {this.state.state_ar && ' / ' + this.state.state_ar}
                  {this.state.locality && ' | Locality:- ' + this.state.locality}
                  {this.state.locality_ar && ' / ' + this.state.locality_ar}
                  {this.state.sublocality && ' | Sublocality:- ' + this.state.sublocality}
                  {this.state.sublocality_ar && ' / ' + this.state.sublocality_ar}
                  {this.state.area && ' | Neighborhood:- ' + this.state.area}
                  {this.state.area_ar && ' / ' + this.state.area_ar}
                  {' | Latitude:- ' + this.state.lat}
                  {' | Longitude:- ' + this.state.lng + ' |'}
                </h6>
              </div>
            </div>
            {this.state.stores.length ? (
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    {this.state.stores.map((item) => (
                      <div
                        className="col-12 col-md-6 col-lg-3 text-center"
                        key={item.id}
                      >
                        <div
                          className="mx-2 my-1 p-2"
                          style={{
                            border: 'solid 1px #80808050',
                            borderRadius: '1rem',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src={item.image ? Constant.getImage() + item.image : './assets/images/icon.png'}
                            className=""
                            alt="store"
                            style={{
                              height: 50,
                              width: 50,
                              borderRadius: '100%',
                              border: 'solid 1px #80808050',
                              objectFit: 'cover',
                            }}
                          />
                          <h5 style={{ marginLeft: 10 }}>{item.name}</h5>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div
                    className="row"
                    style={{ margin: 10 }}
                  >
                    <h5>Stores According to arabic search</h5>
                  </div>
                  <div className="row">
                    {this?.state?.stores_ar?.map((item) => (
                      <div
                        className="col-12 col-md-6 col-lg-3 text-center"
                        key={item.id}
                      >
                        <div
                          className="mx-2 my-1 p-2"
                          style={{
                            border: 'solid 1px #80808050',
                            borderRadius: '1rem',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src={item.image ? Constant.getImage() + item.image : './assets/images/icon.png'}
                            className=""
                            alt="store"
                            style={{
                              height: 50,
                              width: 50,
                              borderRadius: '100%',
                              border: 'solid 1px #80808050',
                              objectFit: 'cover',
                            }}
                          />
                          <h5 style={{ marginLeft: 10 }}>{item.name}</h5>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    )
  }
}
